import { getUserApiData } from "../../utils/UserUtils";
import { invokeApig } from "../../libs/awsLib";
import Paths from "../paths";
import { myID } from "../../libs/generateID";
import store from "../../store/store";
import { notify } from "reapop";
import i18n from "../../i18n";
import { createErrorNotification, createSuccessNotification } from "../../utils/ResponseUtils";

/**
 * @typedef NewAnimalsData
 * @type {object}
 * @property AnmNo1 {string}            Numer zwierzęcia
 * @property RFID {string}              Numer RFID
 */

/**
 * @typedef ReclassifyData
 * @type {object}
 * @property AnmID {string}                     ID zwierzecia
 * @property EvTime {number}                    czas wykonania zdarzeniia (możliwe, że przejdzie do tablicy animals)
 * @property Comment {string}                   komentarz
 * @property GrID {string}                      id grupy
 * @property newAnimals {[NewAnimalsData]}      dane zwierząt utworzonych z tego
 */

/**
 * Metoda wysyła zapytanie o stworzenie przeklasyfikowania tucznika
 * @param data {[ReclassifyData]}           Dane zdarzenia
 * @param FarmID {string|null}              ID fermy
 * @param ClientID {string|null}            ID klienta
 * @param LocalUserID {string|null}         ID użytkownika
 * @return {Promise<*|undefined>}
 */
export function createReclassify(data, { FarmID, ClientID, LocalUserID } = {}) {
    const { _FarmID, _LocalUserID, _ClientID } = getUserApiData({ FarmID, ClientID, LocalUserID });
    return invokeApig({
        ...Paths.createReclassify({ farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID }),
        body: data
    })
}

/**
 * Metoda wysyła zapytanie o stworzenie przeklasyfikowania loszki remontowej
 * @param data {[ReclassifyData]}           Dane zdarzenia
 * @param FarmID {string|null}              ID fermy
 * @param ClientID {string|null}            ID klienta
 * @param LocalUserID {string|null}         ID użytkownika
 * @return {Promise<*|undefined>}
 */
export function createReclassifySow(data, { FarmID, ClientID, LocalUserID } = {}) {
    const { _FarmID, _LocalUserID, _ClientID } = getUserApiData({ FarmID, ClientID, LocalUserID });
    return invokeApig({
        ...Paths.createReclassifySow({ farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID }),
        body: data
    })
}

export function createReclassifyNotificationSuccess(response, { uniqueId = myID() } = {}) {
    if (createSuccessNotification(response, "apiNotifications.createReclassifyTitle")) return;
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("apiNotifications.createReclassifyTitle"),
        message: i18n.t("apiNotifications.createReclassifySuccess"),
        status: 'success',
        dismissible: true,
        dismissAfter: 5000
    }))
}

export function createReclassifyNotificationFailure(response, { uniqueId = myID() } = {}) {
    if (createErrorNotification(response, "apiNotifications.createReclassifyTitle", { uniqueId })) return;
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("apiNotifications.createReclassifyTitle"),
        message: i18n.t("apiNotifications.createReclassifyFailure"),
        status: 'error',
        dismissible: true,
        // buttons: checkLogsButton(),
        dismissAfter: 15000
    }))
}
